import { Disclosure, DisclosureSize } from "@gravity-ui/uikit";
import { useEffect, useMemo, useState } from "react";
import { IKBSection } from "src/widgets/KnowledgeBase/types";

import { DocLink } from "./components";
import styles from "./SectionItem.module.scss";

interface SectionItemProps {
  basePath: string;
  section: IKBSection;
  activeSectionSlug: string;
  onClick?: () => void;
  size: DisclosureSize;
}

export const SectionItem = ({
  basePath,
  section,
  activeSectionSlug,
  onClick,
  size,
}: SectionItemProps) => {
  const isActiveSection = useMemo(
    () => section.slug === activeSectionSlug,
    [section.slug, activeSectionSlug],
  );
  const [expanded, setExpanded] = useState(isActiveSection);

  useEffect(() => {
    setExpanded(isActiveSection);
  }, [isActiveSection]);

  return (
    <Disclosure
      className={`${styles.disclosureCustom}`}
      summary={section.name}
      expanded={expanded}
      onUpdate={setExpanded}
      size={size}
      arrowPosition="start"
    >
      {section.docs.map((doc) => (
        <DocLink
          key={`${section.slug}/${doc.slug}`}
          sectionSlug={section.slug}
          doc={doc}
          basePath={basePath}
          onClick={onClick}
        />
      ))}
    </Disclosure>
  );
};
